import React from 'react';

import { trpcSwr } from '../../../../api/trpc';

type Props = {
  id: string;
};

export const CustomsDeliveryComment: React.FC<Props> = ({ id }) => {
  const { data: order } = trpcSwr.customsDelivery.getOne.useSWR({ id });

  if (!order) {
    return null;
  }

  return (
    <div>
      <div className="d-flex flex-row justify-content-between">
        <div className="fs-18 fw-600 color-gray-450">Комментарий</div>
      </div>
      <div>{order.comment}</div>
    </div>
  );
};
